// assets/lang.js: the first script of every public page on the Studio's host
// (the build puts it at the top of the head). It runs before the page draws.
//
//  - A `?lang=` in the address is saved as the visitor's choice (the cookie
//    the room and the server read) and taken out of the address.
//  - An English page, for a visitor with no saved choice whose browser's
//    first language is one the page has a counterpart in (`data-langs` on
//    <html>), moves to that counterpart. A page in another language never
//    moves a visitor to English by itself; crawlers run no script and read
//    the English page.
import { cookieValue, DEFAULT_LANG, LANG_COOKIE, LANG_COOKIE_SECONDS, LANG_PARAM, langFromLanguages, langFromPath, localePath, parseLang } from "../core/lang.ts";

(() => {
  const secure = location.protocol === "https:";
  // Over HTTPS the Studio's host reads only `__Host-` cookies (server/cookies.ts).
  const name = secure ? `__Host-${LANG_COOKIE}` : LANG_COOKIE;
  const url = new URL(location.href);
  const asked = parseLang(url.searchParams.get(LANG_PARAM));
  if (url.searchParams.has(LANG_PARAM)) {
    if (asked) {
      try {
        document.cookie = `${name}=${asked}; Path=/; Max-Age=${LANG_COOKIE_SECONDS}; SameSite=Lax${secure ? "; Secure" : ""}`;
      } catch {}
    }
    url.searchParams.delete(LANG_PARAM);
    history.replaceState(history.state, "", url);
  }
  const saved = asked ?? parseLang(cookieValue(document.cookie, name)) ?? parseLang(cookieValue(document.cookie, LANG_COOKIE));
  if (saved || langFromPath(location.pathname)) return;
  const wanted = langFromLanguages(navigator.languages ?? [navigator.language]);
  if (wanted === DEFAULT_LANG || !(document.documentElement.dataset.langs ?? "").split(" ").includes(wanted)) return;
  location.replace(localePath(wanted, location.pathname) + location.search + location.hash);
})();
